import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TransformationProduct } from '../models/product.model';
import { PurchaseSeriesRequest } from '../models/purchase.model';
import { Observable } from 'rxjs';
import { ResponseObject } from '../models/response-object.model';

@Injectable({
	providedIn: 'root'
})
export class ProductService {

	private url = environment.api;
	constructor(
		private http: HttpClient,
	) { }

	getCostProduct(idProduct: any) {
		return this.http.get(this.url + "api/erp/inventory/getcostnotvirtual/" + idProduct);
	}

	getProducts(input: string) {
		return this.http.get(this.url + "api/erp/inventory/product/search/existing",
			{
				params: {
					clue: input,
					bought: false,
					sold: true
				}
			}
		);
	}

	getProductsOrdered(input: string, warehouse: any) {
		return this.http.get(
			`${this.url}api/erp/inventory/product/search/order/existing/${warehouse}`,
			{
				params: {
					clue: input,
					bought: false,
					sold: true
				}
			}
		);
	}


	getAllProducts(input: string) {
		return this.http.get(this.url + "api/erp/inventory/product/search/existing",
			{
				params: {
					clue: input,
					bought: true,
					sold: true
				}
			}
		);
	}

	getAllProductsFilteredByFavorite(input: string,  warehouseId?: number | null) {
		const params: any = {
			clue: input,
			bought: true,
			sold: true
		};

		if (warehouseId != null) {
			params.warehouse = warehouseId;
		}

		return this.http.get(this.url + "api/erp/inventory/product/search/existing",
        	{ params }
		);
	}

	getProductsPurchase(input: string) {
		return this.http.get(this.url + "api/erp/inventory/product/search/existing",
			{
				params: {
					clue: input,
					bought: true,
					sold: false
				}
			}
		);
	}

	getCatalogs() {
		return this.http.get(this.url + "api/erp/inventory/product/catalogs");
	}

	getProductList() {
		return this.http.get(this.url + "api/erp/inventory/product");
	}

	activeOrInactive(productId: number) {
		return this.http.delete(this.url + "api/erp/inventory/product/" + productId);
	}

	getProductById(productId: number) {
		return this.http.get(this.url + "api/erp/inventory/product/" + productId);
	}

	postImageProduct(dataURLImage: string) {
		return this.http.post(this.url + "api/erp/inventory/product/picture", dataURLImage);
	}

	updateImageProduct(productId: number, dataURLImage: string) {
		return this.http.post(this.url + "api/erp/inventory/product/picture/" + productId, dataURLImage);
	}

	postProduct(product: any) {
		return this.http.post(this.url + "api/erp/inventory/product", product);
	}

	saveChanges(productId: number, product: any) {
		return this.http.put(this.url + "api/erp/inventory/product/" + productId, product);
	}

	transformProduct(idProductSon: number, idProductFath: number, quantity: number, warehouseId: number, series, number) {
		return this.http.post(this.url + "api/erp/inventory/category/transform",
			{ 
				idProductSon: idProductSon, 
				idProductFath: idProductFath, 
				quantity: quantity, 
				warehouseId: warehouseId,
				series: series,
				number: number 
			}
		);
	}

	getExistence(warehouseId: number, productId: number) {
		return this.http.get(this.url + "api/erp/inventory/product/existence/" + warehouseId + "/" + productId);
	}

	transferProduct(productToTransfer: TransformationProduct) {
		return this.http.post(this.url + "api/erp/inventory/transfer/transformation", productToTransfer);
	}

	transferProductValidation(productToTransfer: TransformationProduct) {
		return this.http.put(this.url + "api/erp/inventory/transfer/transformation/validate", productToTransfer);
	}

	getHistoryProduct(product: number, warehouse: number) {
		return this.http.get(this.url + "api/erp/inventory/dataHistory?productId=" + product + "&warehouse=" + warehouse);
	}

	addSerie(newPurchaseSeries: PurchaseSeriesRequest) {
		return this.http.post(this.url + `api/erp/inventory/product/series`, newPurchaseSeries);
	}

	///
	getAssociateSeriesPurchase(productId: number, providerInvoiceId: number) {
		return this.http.get(this.url + `api/erp/inventory/product/series/purchase/${productId}/${providerInvoiceId}`);
	}

	getAssociateSeriesSale(productId: number, warehouseId: number) {
		return this.http.get(this.url + `api/erp/inventory/product/series/sale/${productId}/${warehouseId}`);
	}

	deleteAssociateSeries(idSeries: number) {
		return this.http.delete(this.url + `api/erp/inventory/product/series/delete/${idSeries}`);
	}

	addClientInvoiceToSeriesProduct(saleInvoiceId: number, series: any[]) {
		return this.http.put(this.url + `api/erp/inventory/product/series/sale/${saleInvoiceId}`, series);
	}

	getIdAssociatedProducts() {
		return this.http.get(this.url + `api/erp/inventory/product/productsAssociated`);
	}

	getAssociatedProductsByCode(idAssociated: string) {
		return this.http.get(this.url + `api/erp/inventory/product/productsAssociated/${idAssociated}`);
	}

	getMeasurementsByMeasurementId(measurementId: number) {
		return this.http.get(this.url + `api/erp/inventory/product/measurements/${measurementId}`);
	}

	getMeasurementsByProductId(productId: number): Observable<ResponseObject> {
		return this.http.get<ResponseObject>(this.url + `api/erp/inventory/product/measurements-by-product/${productId}`);
	}
}
